export default __webpack_public_path__ + "static/media/logo.bc5b6bde.svg";